import { FC } from 'react';
import { HeaderModel } from '../../models/CommonModel';
import SortableColumn from '../../components/Table/SortableColumn';
import { MstTaxGroupModel } from '../../models/MstTaxGroupModel';

type Props = {
    data: Array<MstTaxGroupModel>,
    arrDelete: number[],
    onEdit: (taxGroup: MstTaxGroupModel) => void
    handleDelete: (taxGroup: MstTaxGroupModel) => void
    header: HeaderModel[]
    hideCols: string[],
    openColConfig: () => void,
    handleSort: (sortBy: string, direction: 'asc' | 'desc' | 'none') => void
};

const TaxGroupTable: FC<Props> = ({ data, handleDelete, onEdit, header, hideCols, openColConfig, handleSort }) => {

    return (
        <div className='table-responsive'>
            <table className="table table-hover table-bordered table-striped border gy-7 gs-7">
                <thead>
                    <tr className='fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200'>
                        <th>
                            <i 
                                className="fa fa-cogs"
                                style={{cursor: 'pointer'}}
                                onClick={openColConfig}
                            ></i>
                        </th>
                        {header.map((th, index) => {
                            if (!hideCols.includes(th.field)) {
                                if (th.sortable) {
                                    return (
                                        <SortableColumn
                                            key={'th-' + index}
                                            sortBy={th?.field}
                                            onSortChange={handleSort}
                                            style={th?.style ?? {}}
                                        >
                                            {th.label}
                                        </SortableColumn>
                                    )
                                }
                                return (
                                    <th style={th?.style ?? {}}>{th.label}</th>
                                )
                            }
                        })}
                        <th style={{ minWidth: "150px" }}></th>
                    </tr>
                </thead>
                <tbody>
                    {data?.map((item: MstTaxGroupModel, index: number) => {
                        return (
                            <tr key={`agent_${index}`} className="cursor-pointer">
                                <td></td>
                                {!hideCols.includes('name') && (
                                <td>{item.name}</td>
                                )}
                                {!hideCols.includes('vat_rate') && (
                                <td>{Number(item.vat_rate)}%</td>
                                )}
                                {!hideCols.includes('pit_rate') && (
                                <td>{Number(item.pit_rate)}%</td>
                                )}
                                {!hideCols.includes('effective_from') && (
                                <td>
                                    {item.effective_from && (
                                        <>Từ: {item.effective_from}<br/></>
                                    )}
                                    {item.effective_to && (
                                        <>Đến: {item.effective_to}</>
                                    )}
                                </td>
                                )}
                                <td className='text-center'>
                                    <button onClick={() => onEdit(item)} className="btn btn-icon btn-light-warning w-30px h-30px ps-2 me-2">
                                        <i className="bi bi-pencil-square fs-4 me-2"></i>
                                    </button>
                                    {/* <button onClick={() => handleDelete(item)} className="btn btn-icon btn-light-danger w-30px h-30px ps-2 me-2">
                                        <i className="bi bi-trash fs-4 me-2"></i>
                                    </button> */}
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div >
    );
}

export default TaxGroupTable;